import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import COLORS from "../../../../constants/Colors";
import TabHeading from "../../../common/tabs/TabHeading";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import NearMeRoundedIcon from "@mui/icons-material/NearMeRounded";
import OutboundIcon from "@mui/icons-material/Outbound";
import useNetworkRequest from "../../../../hooks/NetworkRequest";
import DetailLoading from "../detail-loading/DetailLoading";
import APP_CONSTANTS from "../../../../constants/AppConstants";
import { ENDPOINTS, urlWithPrefix } from "../../../../configs/APIConfig";
import { useNavigate } from "react-router-dom";
import TrackingDetailError from "./TrackingDetailError";
import TruckOutlineIcon from "@mui/icons-material/LocalShippingOutlined";
import WheelzMap from "../../../common/maps/WheelzMap";
import StopTrackingDialog from "./StopTrackingDialog";
import HistoryIcon from "@mui/icons-material/History";
import ShareIcon from "@mui/icons-material/Share";
import shareTrackingToClipboard from "./ShareTracking";
dayjs.extend(duration);
dayjs.extend(utc);

// const TEMP_TRACKING_DATA = [
//   {
//     seq_no: "Truck",
//     lane_direction: "N",
//     txn_time: "2025-01-18T12:24:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "S",
//     txn_time: "2025-01-18T16:33:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "E",
//     txn_time: "2025-01-21T09:21:02Z",
//     tollplaza: "Bhagan Toll Plaza",
//     tollplaza_loc: "29.071744,77.0601904",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "N",
//     txn_time: "2025-01-18T12:24:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "W",
//     txn_time: "2025-01-18T16:33:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "S",
//     txn_time: "2025-01-21T09:21:02Z",
//     tollplaza: "Bhagan Toll Plaza",
//     tollplaza_loc: "29.071744,77.0601904",
//   },

//   {
//     seq_no: "Truck",
//     lane_direction: "N",
//     txn_time: "2025-01-18T12:24:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "S",
//     txn_time: "2025-01-18T16:33:15Z",
//     tollplaza: "Mayar Toll Plaza",
//     tollplaza_loc: "29.100827,75.885338",
//   },
//   {
//     seq_no: "Truck",
//     lane_direction: "S",
//     txn_time: "2025-01-21T09:21:02Z",
//     tollplaza: "Bhagan Toll Plaza",
//     tollplaza_loc: "29.071744,77.0601904",
//   },
// ];

const TrackingExpBanner = ({ until, limit }) => {
  const untilDate = dayjs(until);
  const now = dayjs();
  const diff = untilDate.diff(now);
  const pendingDuration = dayjs.duration(diff);
  const pendingDays = Math.floor(pendingDuration.asDays());
  const pendingHours = pendingDuration.hours();
  const totalRemHours = pendingDuration.asHours();
  const formattedUntil = dayjs(until).format("DD MMM YYYY, hh:mm a");
  return (
    <Box
      sx={{
        width: "100%",
        mt: "20px",
        background: "var(--input-field-active)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderRadius: "4px",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: "50px",
            width: "50px",
            background: COLORS.TRACKING_GREEN,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "4px",
          }}
        >
          <NearMeRoundedIcon sx={{ fontSize: "1.6rem", color: "white" }} />
        </Box>
        <Typography
          fontSize={"0.9rem"}
          fontWeight={600}
          sx={{
            ml: "20px",
            opacity: "0.8",
          }}
        >
          Till {formattedUntil}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "end",
          mr: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            mr: "5px",
            height: "6px",
            width: "150px",
            background: "#D2D2D2",
            borderRadius: "3px",
          }}
        >
          <Box
            sx={{
              height: "6px",
              width: `${150 * (totalRemHours / (limit * 24))}px`,
              background: COLORS.TRACKING_GREEN,
              borderRadius: "3px",
            }}
          />
        </Box>
        <Typography
          fontSize={"0.9rem"}
          fontWeight={600}
          sx={{
            opacity: "0.8",
          }}
        >
          {pendingDays}d {pendingHours}h
        </Typography>
      </Box>
    </Box>
  );
};

function TrackingDetail() {
  const { transferBin, settransferBin, setexpandedView } = useDashLayoutCtx();
  const closeDetailView = () => {
    settransferBin(null);
    setexpandedView(false);
  };
  const { fetchData } = useNetworkRequest();
  const abortControllerRef = useRef(null);
  const [trackingData, settrackingData] = useState(null);
  const [openStopDialog, setopenStopDialog] = useState(false);

  useEffect(() => {
    if (transferBin?.vehRegNo) {
      getTrackingDetails();
    }

    //eslint-disable-next-line
  }, [transferBin]);

  const [selectedIndex, setselectedIndex] = useState(0);
  const handleTollNameClick = (index) => {
    setselectedIndex(index);
  };

  const closeFuncForLoading = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    closeDetailView();
  };

  const navigate = useNavigate();
  const navToErrorScreen = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    navigate("/error", {
      state: {
        releaseProtection: true,
      },
    });
  };

  const [renderComponent, setrenderComponent] = useState(<></>);

  const getTrackingDetails = async () => {
    settrackingData(null);
    setrenderComponent(
      <DetailLoading
        closeFunc={closeFuncForLoading}
        vehRegNo={transferBin?.vehRegNo}
      />
    );
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const payload = {
      vehicle_number: transferBin.vehRegNo.replaceAll(" ", ""),
    };

    const timeoutPromise = new Promise((resolve) =>
      setTimeout(resolve, APP_CONSTANTS.TRACKING_DETAIL_LOADING_MIN_DELAY)
    );

    try {
      const fetchPromise = fetchData({
        url: urlWithPrefix(ENDPOINTS.DASHBOARD.TRACKING.GET_TRACKING.url),
        method: ENDPOINTS.DASHBOARD.TRACKING.GET_TRACKING.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
        body: payload,
      });

      const [resp] = await Promise.all([fetchPromise, timeoutPromise]);
      if (resp?.data?.data?.transactions) {
        let dataToSet = resp?.data?.data;
        dataToSet.valid_until = resp?.data?.valid_until;
        dataToSet.validity_limit = resp?.data?.validity_limit;
        dataToSet.last_refreshed = resp?.data?.last_refreshed;
        settrackingData(dataToSet);
      } else {
        setrenderComponent(
          <TrackingDetailError
            closeFunc={closeDetailView}
            vehRegNo={transferBin?.vehRegNo || ""}
            failedFetch
          />
        );
      }
    } catch (error) {
      const [e] = await Promise.all([error, timeoutPromise]);
      if (
        e.status === 400 &&
        e?.response?.data?.error?.code ===
          "no active tracking request found for this vehicle and requester"
      ) {
        setrenderComponent(
          <TrackingDetailError
            closeFunc={closeDetailView}
            vehRegNo={transferBin?.vehRegNo || ""}
            noActiveReq
          />
        );
      } else {
        console.error("Tracking Details Error", e);
        if (e.code !== "ERR_CANCELED") {
          navToErrorScreen();
        }
      }
    }
  };

  const TopActions = () => {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          color="red"
          sx={{
            cursor: "pointer",
            visibility: "hidden",
          }}
          onClick={() => {
            setopenStopDialog(true);
          }}
        >
          STOP
        </Typography>
        <Typography fontSize={"0.9rem"} fontWeight={600} letterSpacing={"2px"}>
          {transferBin?.vehRegNo}
        </Typography>
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          color={COLORS.PRIMARY}
          onClick={closeDetailView}
          sx={{
            cursor: "pointer",
          }}
        >
          CLOSE
        </Typography>
      </Box>
    );
  };

  const TollMapView = () => {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "calc(100% - 40px)",
            background: COLORS.DASH_BG,
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <WheelzMap
            lat={
              trackingData?.transactions[selectedIndex].tollplaza_loc.split(
                ","
              )[0]
            }
            lng={
              trackingData?.transactions[selectedIndex].tollplaza_loc.split(
                ","
              )[1]
            }
            xOffset={"250"}
            height="100%"
            label={trackingData?.transactions[selectedIndex].tollplaza}
          />
        </Box>
        <Typography
          fontSize={"0.8rem"}
          textAlign={"center"}
          sx={{
            opacity: "0.5",
            mt: "10px",
            width: "100%",
            cursor: "pointer",
            display: "flex",
            flexDirection: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HistoryIcon
            sx={{
              mr: "5px",
              fontSize: "20px",
              opacity: "0.5",
            }}
          />
          Last refreshed at{" "}
          {dayjs(trackingData.last_refreshed).format("DD MMM YYYY, hh:mm a")}
        </Typography>
      </Box>
    );
  };

  const shareTracking = () => {
    let directionMap = {
      N: "North",
      S: "South",
      E: "East",
      W: "West",
    };
    shareTrackingToClipboard({
      vehNo: transferBin?.vehRegNo,
      manufName: transferBin?.mnfcName || "",
      ownerName: transferBin?.ownerName || "",
      lastTollName: trackingData?.transactions[0].tollplaza,
      lastTollTime: dayjs(trackingData?.transactions[0].txn_time).utc().format("DD MMM YYYY, hh:mm a"),
      direction: directionMap[trackingData?.transactions[0].lane_direction] || "",
      lastUpdated: dayjs(trackingData?.last_refreshed).format("DD MMM YYYY, hh:mm a"),
      lat: trackingData?.transactions[0].tollplaza_loc.split(",")[0],
      lng: trackingData?.transactions[0].tollplaza_loc.split(",")[1],
    });
  };

  return (
    <Box
      sx={{
        width: "calc(100% - 40px)",
        height: "calc(100% - 40px)",
        display: "flex",
        flexDirection: "column",
        margin: "20px",
      }}
    >
      {trackingData?.transactions && (
        <>
          <StopTrackingDialog
            open={openStopDialog}
            vehRegNo={transferBin?.vehRegNo?.replaceAll(" ", "")}
            closeFunc={() => {
              setopenStopDialog(false);
            }}
          />
          <TopActions />
          <TrackingExpBanner
            until={trackingData?.valid_until}
            limit={trackingData?.validity_limit}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              mt: "20px",
              borderRadius: "4px",
              position: "relative", // Add relative positioning to the parent box
            }}
          >
            <TollMapView />
            <Box
              sx={{
                height: "calc(100% - 80px)",
                width: "500px",
                background: "white",
                position: "absolute", // Add absolute positioning to the new box
                m: "20px",
                zIndex: 1, // Ensure the new box is on top
                borderRadius: "4px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "20px",
                  height: "calc(100% - 40px)",
                }}
              >
                <TabHeading
                  heading="FASTAG HISTORY"
                  hasAction
                  actionLabel="SHARE"
                  actionIcon={<ShareIcon />}
                  actionFunc={shareTracking}
                />
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    mt: "20px",
                  }}
                >
                  <Timeline
                    sx={{
                      [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.2,
                      },
                    }}
                  >
                    <TimelineItem
                      sx={{
                        height: "100px",
                      }}
                    >
                      <TimelineOppositeContent color="textSecondary">
                        {" "}
                        <Box
                          sx={{
                            width: "95px",
                          }}
                        />
                      </TimelineOppositeContent>
                      <TimelineSeparator
                        sx={{
                          ml: "-10px",
                        }}
                      >
                        <Box
                          sx={{
                            height: "40px",
                            width: "40px",
                            borderRadius: "50%",
                            background: COLORS.TRACKING_GREEN,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <TruckOutlineIcon
                            sx={{
                              fontSize: "1.8rem",
                              color: "white",
                            }}
                          />
                        </Box>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent></TimelineContent>
                    </TimelineItem>
                    {trackingData?.transactions.map((item, index) => {
                      const date = dayjs(item.txn_time).utc();
                      const txnDate = date.format("D MMM YYYY");
                      const txnTime = date.format("h:mm A");
                      const rotateMap = {
                        N: "-45deg",
                        S: "135deg",
                        E: "45deg",
                        W: "-135deg",
                      };
                      return (
                        <TimelineItem
                          key={index}
                          sx={{
                            height: "120px",
                          }}
                        >
                          <TimelineOppositeContent color="textSecondary">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                                mt: "-28px",
                                width: "100px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "5px",
                                  background: "var(--tracking-latest-chip-bg)",
                                  borderRadius: "4px",
                                  width: "fit-content",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "1px 5px",
                                  visibility:
                                    index === 0 ? "visible" : "hidden",
                                  mb: "5px",
                                }}
                              >
                                <NearMeRoundedIcon
                                  sx={{
                                    color: "white",
                                    fontSize: "1.2rem",
                                  }}
                                />
                                <Typography
                                  fontSize={"0.9rem"}
                                  fontWeight={500}
                                  color="white"
                                >
                                  Latest
                                </Typography>
                              </Box>
                              <Typography
                                fontSize={"0.9rem"}
                                fontWeight={500}
                                sx={{
                                  opacity: 0.5,
                                }}
                              >
                                {txnDate}
                              </Typography>
                              <Typography
                                fontSize={"0.9rem"}
                                fontWeight={500}
                                sx={{
                                  opacity: 0.5,
                                }}
                              >
                                {txnTime}
                              </Typography>
                            </Box>
                          </TimelineOppositeContent>
                          <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector
                              sx={{
                                opacity:
                                  index ===
                                  trackingData?.transactions.length - 1
                                    ? 0.2
                                    : 1,
                              }}
                            />
                          </TimelineSeparator>
                          <TimelineContent>
                            <Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "5px",
                                  background: "black",
                                  borderRadius: "4px",
                                  width: "fit-content",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "1px 5px",
                                  mb: "5px",
                                  mt: "-28px",
                                }}
                              >
                                <OutboundIcon
                                  sx={{
                                    color: "white",
                                    fontSize: "1rem",
                                    rotate: rotateMap[item.lane_direction],
                                  }}
                                />
                                <Typography
                                  fontSize={"0.9rem"}
                                  fontWeight={700}
                                  color="white"
                                >
                                  {item.lane_direction}
                                </Typography>
                              </Box>
                              <Typography
                                fontSize={"0.9rem"}
                                fontWeight={600}
                                color={
                                  selectedIndex === index
                                    ? COLORS.PRIMARY
                                    : null
                                }
                                onClick={() => handleTollNameClick(index)}
                                sx={{
                                  opacity: 0.75,
                                  cursor: "pointer",
                                }}
                              >
                                {item.tollplaza}
                              </Typography>
                            </Box>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    })}
                  </Timeline>
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      )}
      {!trackingData?.transactions && transferBin && renderComponent}
    </Box>
  );
}

export default TrackingDetail;
